import { render, staticRenderFns } from "./PapercleanConfigurazioneIvaEditModalComponent.vue?vue&type=template&id=1728764b"
import script from "./PapercleanConfigurazioneIvaEditModalComponent.vue?vue&type=script&lang=js"
export * from "./PapercleanConfigurazioneIvaEditModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports